import AccordionSection from '@app/components/common/Accordion/AccordionSection';
import { IAccordionSection } from '@app/components/common/Accordion/AccordionSection/types';
import Table from '@app/components/common/Table';
import Typography from '@app/components/common/Typography';
import { useMemo } from 'react';
import { columnHelper, IUserPayHoursTable, ROW_ID_PREFIX } from './types';
import MoneyInput from '@app/components/common/MoneyInput';
import { WithTranslation } from 'react-i18next';
import Box from '@app/components/common/Box';
import { ParseKeys } from 'i18next';

interface IPayHours extends Pick<WithTranslation, 't'>, IAccordionSection {}

const PayHours = ({ t, ...accordionSectionProps }: IPayHours) => {
  //TODO gather this data from state
  const tableMockData: IUserPayHoursTable[] = [
    {
      id: 1,
      type: 'weekly',
      defaultHours: 40,
      defaultOvertimeFactor: 1.5,
      overrideHours: 45,
      overrideOvertimeFactor: 1.6,
    },
    {
      id: 2,
      type: 'daily',
      defaultHours: 8,
      defaultOvertimeFactor: 1.2,
      overrideHours: 9,
      overrideOvertimeFactor: 1.7,
    },
  ];

  const COLUMN_VALUES = useMemo(
    () => [
      columnHelper.accessor('type', {
        header: t('settingsModule.usersSettings.payHours.table.type.header'),
        cell: info => {
          const type = info.row.original.type;
          return (
            <Typography>
              {t(
                `settingsModule.usersSettings.payHours.table.type.values.${type}` as ParseKeys,
              )}
            </Typography>
          );
        },
        size: 200,
      }),
      columnHelper.accessor('defaultHours', {
        header: t(
          'settingsModule.usersSettings.payHours.table.defaultHours.header',
        ),
        cell: info => <Typography>{info.row.original.defaultHours}</Typography>,
        minSize: 200,
      }),
      columnHelper.accessor('defaultOvertimeFactor', {
        header: t(
          'settingsModule.usersSettings.payHours.table.defaultOvertimeFactor.header',
        ),
        cell: info => (
          <Typography>{info.row.original.defaultOvertimeFactor}</Typography>
        ),
        minSize: 200,
      }),
      columnHelper.accessor('overrideHours', {
        header: t(
          'settingsModule.usersSettings.payHours.table.overrideHours.header',
        ),
        cell: info => (
          <Box csx={[{ maxWidth: '50%' }]}>
            <MoneyInput
              required
              placeholder={t(
                'settingsModule.usersSettings.payHours.table.overrideHours.placeholder',
              )}
              value={info.getValue()}
              prefix=""
              precision={0}
              onValueChange={() => null}
            />
          </Box>
        ),
        minSize: 200,
      }),
      columnHelper.accessor('overrideOvertimeFactor', {
        header: t(
          'settingsModule.usersSettings.payHours.table.overrideOvertimeFactor.header',
        ),
        cell: info => (
          <Box csx={[{ maxWidth: '50%' }]}>
            <MoneyInput
              required
              placeholder={t(
                'settingsModule.usersSettings.payHours.table.overrideOvertimeFactor.placeholder',
              )}
              value={info.getValue()}
              prefix=""
              precision={1}
              onValueChange={() => null}
            />
          </Box>
        ),
        minSize: 200,
      }),
    ],
    [t],
  );

  return (
    <>
      <AccordionSection
        title={t('settingsModule.usersSettings.payHours.title')}
        {...accordionSectionProps}>
        <Table
          scrollEnabled
          nestedScrollEnabled
          headerCellCsx={{ paddingLeft: 4 }}
          data={tableMockData}
          columns={COLUMN_VALUES}
          rowIdPrefix={ROW_ID_PREFIX}
          cellCsx={{ height: '70px' }}
          renderEmptyValues
        />
      </AccordionSection>
    </>
  );
};

export default PayHours;
